'use client'

import { useEffect } from 'react'
import { useAnalytics } from '@/hooks/useAnalytics'

export function ProjectDetailWrapper({
  projectName,
  slug: _slug,
}: {
  projectName: string
  slug: string
}) {
  const { track } = useAnalytics()

  useEffect(() => {
    // Track project detail view when component mounts
    track('project_view', {
      project_name: projectName,
      source: 'project_navigation',
    })
  }, [projectName, track])

  return null
}
